import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Body from "./body";
import Login from "../modules/login";
import Storage from "./../services/local-store";
import postService from "./../services/httpService";
import TokenGenerator from "../modules/token/TokenGenerator";
import Biller from "../modules/biller/Biller";
import Operator from "../modules/operator/Operator";
import networkList from "../constants/networkList";

import QueuepatientDetailshell from './../modules/operator/shell/index.js';
import moment from "moment";




const $ = require("jquery");
require("bootstrap");

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      tvScreens: []
    };
   }
  componentDidMount() {
    
    this.checkAuthToken();
    
    if ($(".App").outerHeight(true) > $(window).height()) {
      $("footer").css({ position: "relative", top: "10px" });
    } else {
      $("footer").css({ position: "relative", top: "unset" });
    }}
   
  

 
  checkAuthToken() { 
    const setHref = (str) => (window.location.href = str);
    const currenthref = window.location.pathname;
    
    let search = window.location.search
    let params = new URLSearchParams(search);
    let uid = params.get('uid');

    if (currenthref !== "/tv-display") {
      postService("checkAuthToken", "GET", null).then(async(res) => {
        if(uid !== undefined && uid !== '' && uid !== null){
          await this.getMasterTvDisplays();
          let thisTvScreen = currenthref.split('/')
          if (!res.success && !res.status) {
            if (
              currenthref !== "/tv-settings/start-counter" &&
              currenthref !== "/" &&
              !(this.state.tvScreens.includes(thisTvScreen[2]))
            ) {
              Storage.clearAll();
              setHref("/");
            }
          }
        }
      });
    }
  }
 
 
async getMasterTvDisplays(){
    let search = window.location.search
    let params = new URLSearchParams(search);
    let uid = params.get('uid');
    const { getMasterTvDisplays } = networkList;

    await postService(getMasterTvDisplays, "POST", { data: { uid : uid } }).then((res) => {
      if (res.status) {
        this.setState((state) => ({
          tvScreens : res.data.map(a => a.tv_display_name)
        }));
      } else {
        this.setState({ tvScreens: [] });
      }
    })
  }

    // if (currenthref !== "/tv-display") {
    //       postService("checkAuthToken", "GET", null).then(async(res) => {
    //         if(uid !== undefined && uid !== '' && uid !== null){
    //           // await postService('getMasterTvDisplays', "POST", { data: { uid : uid } }).then((res) => {
    //             // if (res.status) {
    //             //   console.log(res.data.map(a => a.tv_display_name))
    //             //   tvScreens = res.data.map(a => a.tv_display_name)
    //             //   console.log(tvScreens)
    
    //               let thisTvScreen = currenthref.split('/')
    //               if (!res.success && !res.status) {
    //                 if (
    //                   currenthref !== "/tv-settings/start-counter" &&
    //                   currenthref !== "/" &&
    //                   // tvScreens.includes(thisTvScreen[2])
    //                   currenthref !== "/tv-screen/tv1" &&
    //                   currenthref !== "/tv-screen/tv2" &&
    //                   currenthref !== "/tv-screen/tv3" &&
    //                   currenthref !== "/tv-screen/tv4" &&
    //                   currenthref !== "/tv-screen/tv5" &&
    //                   currenthref !== "/tv-screen/6opd-gf-tv" &&
    //                   currenthref !== "/tv-screen/7opd-gf-tv" &&
    //                   currenthref !== "/tv-screen/7opd-ff-tv" &&
    //                   currenthref !== "/tv-screen/7obg-ff-tv" &&
    //                   currenthref !== "/tv-screen/6opd-ff-tv" &&
    //                   currenthref !== "/tv-screen/6obg-ff-tv" 
    //                 ) {
    //                   Storage.clearAll();
    //                   setHref("/");
    //                 }
    //               }
    //           //   }
    //           // })
    //         }
    //       });
    //     }
    //   }

  //   if (currenthref !== "/tv-display") {
  //     postService("checkAuthToken", "GET", null).then(async(res) => {
  //       if(uid !== undefined && uid !== '' && uid !== null){
  //         await postService('getMasterTvDisplays', "POST", { data: { uid : uid } }).then((res) => {
  //           if (res.status) {
  //             console.log(res.data.map(a => a.tv_display_name))
  //             tvScreens = res.data.map(a => a.tv_display_name)
  //             console.log(tvScreens)

  //             let thisTvScreen = currenthref.split('/')
  //             if (!res.success && !res.status) {
  //               if (
  //                 currenthref !== "/tv-settings/start-counter" &&
  //                 currenthref !== "/" &&
  //                 tvScreens.includes(thisTvScreen[2])
  //                 // currenthref !== "/tv-screen/tv1" &&
  //                 // currenthref !== "/tv-screen/tv2" &&
  //                 // currenthref !== "/tv-screen/tv3" &&
  //                 // currenthref !== "/tv-screen/tv4" &&
  //                 // currenthref !== "/tv-screen/tv5" &&
  //                 // currenthref !== "/tv-screen/6opd-gf-tv" &&
  //                 // currenthref !== "/tv-screen/7opd-gf-tv" &&
  //                 // currenthref !== "/tv-screen/7opd-ff-tv" &&
  //                 // currenthref !== "/tv-screen/7obg-ff-tv" &&
  //                 // currenthref !== "/tv-screen/6opd-ff-tv" &&
  //                 // currenthref !== "/tv-screen/6obg-ff-tv" 
  //               ) {
  //                 Storage.clearAll();
  //                 setHref("/");
  //               }
  //             }
  //           }
  //         })
  //       }
  //     });
  //   }
  // }
 
  render() {
    return (
      <div className="App">
        <Router>
          <Route exact path="/" component={Login} />
          <Route exact path="/:id/:slug?" component={Body} />
        </Router>
      </div>
    );
  }
}

export default App;

